import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Context } from 'src/app/shared/models/context';
import { Message } from 'src/app/shared/models/domain';
import { Separation, StatusTracking } from 'src/app/shared/models/separation';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { SeparationService } from 'src/app/shared/services/separation.service';
@Component({
  selector: 'app-lone-status',
  templateUrl: './lone-status.component.html',
  styleUrls: ['./lone-status.component.scss']
})
export class LoneStatusComponent implements OnInit {
  @Input() context: Context;
  @Input() separationId: number;

  public separation: Separation;
  public submitted: boolean = false;
  public statusForm: FormGroup;
  private modified: boolean = false;
  public statuses: string;
  public statusTracking: StatusTracking[];
  public reportedTo: any;
  public addressTo: any;

  constructor(
    private separationService: SeparationService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private authService: AuthService,
  ) { }

  ngOnInit(): void {
    this.context = this.authService.getContextData();
    this.separationService.getStatus().subscribe(statuses=>(this.statuses = statuses));    
    this.setStatusForm(); 
    this.getStatusTracking();
  }

  public getStatusTracking(){
    if (this.separationId) {
      this.separationService.getStatusTrackings(this.separationId).subscribe(separation => {
        if (Array.isArray(separation)) { 
          const loneApprovals = separation.filter(sep => sep.stage === "LONE_APPROVAL");
          this.reportedTo = loneApprovals.reverse().find(sep => sep.comments !== null) || loneApprovals[0] || null;
          if (this.reportedTo) {
            this.statusForm.get('id')?.setValue(this.reportedTo.id);
            this.statusForm.get('stage')?.setValue(this.reportedTo.stage); 
            this.statusForm.get('resignationStatus')?.setValue(this.reportedTo.resignationStatus);
            this.statusForm.get('comments')?.setValue(this.reportedTo.comments);                    
          }
        } 
      });
    }
  }

  public setStatusForm(status?: StatusTracking) {
    if (!status) status = {
      id: null,
      comments: null,
      stage: "REVIEW",
      resignationStatus: "PENDING",
      separationId: this.separationId,
      approverId: this.context.employeeId,
    } as StatusTracking
    this.statusForm = this.fb.group({
      id: this.fb.control(status?.id),
      comments: this.fb.control(status?.comments, [Validators.required]),
      stage: this.fb.control(status?.stage, []),
      resignationStatus: this.fb.control(status?.resignationStatus, []),
      separationId: this.fb.control(status?.separationId, [Validators.required]),
      approverId: this.fb.control(status?.approverId, [Validators.required]),
    });
    this.statusForm.valueChanges.subscribe(value => this.modified = true);
  }

  get s() {
    return this.statusForm.controls;
  }

  public saveStatus() {
    this.submitted = true;
    this.statusForm.markAllAsTouched();
  
    if (this.statusForm.valid) {
      let status: StatusTracking = this.statusForm.value as StatusTracking;
      if (status.id) {
        this.separationService.updateStatusTracking(status.id, status).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, "Status Updated successfully");
            } else {
              this.commonService.setToastr(500, message.text);
            }
          },
          error: (err) => {
            this.commonService.setToastr(500, "Error Updating Status");
          }
        });
      } else {
        this.separationService.createStatusTracking(status).subscribe({
          next: (message: Message) => {
            if (!message.failed) {
              this.commonService.setToastr(200, "Status Saved successfully");
            } else {
              this.commonService.setToastr(500, message.text);
            }
          },
          error: (err) => {
            this.commonService.setToastr(500, "Error Saving Status");
          }
        });
      }
  
    } else {
      this.commonService.setToastr(400, "Please enter valid Status details!");
    }
  }
  

}


